import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=7292e2da"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7292e2da')) {
      api.createRecord('7292e2da', component.options)
    } else {
      api.reload('7292e2da', component.options)
    }
    module.hot.accept("./Exam.vue?vue&type=template&id=7292e2da", function () {
      api.rerender('7292e2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/exam/Exam.vue"
export default component.exports